import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";
import { REQUEST_ID_HEADER, showErrorDialog } from "../../../../scripts/jobCompletion";

export default class MagicallyOpenClonedDestinationController extends Controller {
    static values = {
        getClonedDestinationUniqueIdUrl: String,
        destinationDetailUrl: String
    };

    readonly getClonedDestinationUniqueIdUrlValue!: string;
    readonly destinationDetailUrlValue!: string;

    async connect() {
        const response = await fetch(this.getClonedDestinationUniqueIdUrlValue, { method: "POST" });
        if (response.ok) {
            const clonedDestinationUniqueId = await response.text();
            const clonedDestinationDetailUrl = this.destinationDetailUrlValue.replace("$uniqueId", clonedDestinationUniqueId);

            // todo: how about this: trackEvent('destinationCreated', { language, baseDestinationUid: destinationUniqueId, destinationUid: clonedDestinationUniqueId });

            Turbo.visit(clonedDestinationDetailUrl);
        }
        else {
            const requestId = response.headers.get(REQUEST_ID_HEADER) || undefined;
            showErrorDialog("Failed to open the destination. Please refresh the page.", requestId);
        }
    }
}
